module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-580@2x-d6ac0f3e4bf73ac4df292b62510eb17e.webp";